import { Geography } from "react-simple-maps";
import { CountryItem } from "./Map";

type GeoItem = {
    id: string;
    rsmKey: string;
    geometry: {
        coordinates: [number, number][];
        type: string;
    };
    svgPath: string;
    type: string;
    properties: {
        "Alpha-2": string;
        name: string;
    };
};

type MapCountryProps = {
    geo: GeoItem;
    colors: CountryItem[];
    hoveredCountries?: string[];
};

const defaultCountryColor = "#e1e7dc";

const MapCountry = ({ geo, colors, hoveredCountries }: MapCountryProps) => {
    let fillColor = defaultCountryColor;

    if (
        (hoveredCountries &&
            hoveredCountries?.length > 0 &&
            hoveredCountries.includes(geo.id)) ||
        hoveredCountries?.length === 0 ||
        !hoveredCountries
    ) {
        fillColor =
            colors.find((c) => c.countryCode === geo.id)?.color ??
            defaultCountryColor;
    }

    return <Geography key={geo.rsmKey} geography={geo} fill={fillColor} />;
};

export default MapCountry;
